// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
    width: 400px;
    margin: 0 auto;
    text-align: center;
    background-color: white;
    padding: 25px;
    border-radius: 10px;
}

label {
    position: relative;
}

.password-visibility-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #333333;
    font-size: 21px;
}

.login-form input[type=text], .login-form input[type=password] {
    padding-right: 35px;
}`, "",{"version":3,"sources":["webpack://./src/Authentication/LoginForm.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".login-form {\n    width: 400px;\n    margin: 0 auto;\n    text-align: center;\n    background-color: white;\n    padding: 25px;\n    border-radius: 10px;\n}\n\nlabel {\n    position: relative;\n}\n\n.password-visibility-icon {\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    color: #333333;\n    font-size: 21px;\n}\n\n.login-form input[type=text], .login-form input[type=password] {\n    padding-right: 35px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
